import {
    getData, postData, postFormData, deleteData
} from '../../../common/utils/network.utils';


export const getMagicBoxData = async () => {
    return (await getData("magic-box")).data;
}

export const getAll = async () => {
    return (await getData("magic-box"))?.data;
}

export const getLLMResult = async () => {
    return (await getData(`magic-box/llm_results`)).data;
}

export const uploadDocuments = async (formData) => {
    return (await postFormData(`magic-box`, formData))
}

export const uploadLLMDocument = async (formData) => {
    return (await postFormData(`magic-box/llm`, formData))
}

export const deleteDocument = async (documentId) => {
    return (await deleteData(`magic-box/${documentId}`));
}

export const confirmLLM = async (sendUploadConfirmationEmail, status, notes) => {
    return (await postData("magic-box/confirm", { sendUploadConfirmationEmail, status, notes })).data;
}

export const getFileLLMStatus = async (fileId) => {
    return (await getData(`magic-box/llm_status/${fileId}`)).data;
}

export const getCurrencyRate = async (currency) => {
    return (await getData(`currencies/live-currency-rate/${currency}`)).data;
}

export const addItems = async (items) => {
    return (await postData("assets/bulk", items));
}

export const updateFileNotes = async (fileId, notes) => {
    return (await postData(`magic-box/${fileId}/notes`, { notes })).data;
}

export const updateFilesStatus = async (ids, status) => {
    return (await postData(`magic-box/status`, { ids, status })).data;
}

export const submitFiles = async (ids, status, notes) => {
    return (await postData(`magic-box/submit`, { ids, status, notes })).data;
}